import { Chip } from '@mui/material';

/** Chip discreto: ativo em verde contornado, inativo em cinza preenchido. */
export function StatusAtivoChip({
  ativo,
  labelAtivo = 'Ativo',
  labelInativo = 'Inativo',
}) {
  const on = !!ativo;
  return (
    <Chip
      size="small"
      label={on ? labelAtivo : labelInativo}
      color={on ? 'success' : 'default'}
      variant={on ? 'outlined' : 'filled'}
      sx={{
        fontWeight: 700,
        ...(on ? {} : { bgcolor: 'grey.300', color: 'text.secondary' }),
      }}
    />
  );
}

/** Linha inativa fica levemente apagada, sem pintar a tabela de vermelho. */
export function sxLinhaInativa(ativo) {
  if (ativo) return {};
  return {
    bgcolor: 'grey.100',
    '& td': { color: 'text.secondary' },
  };
}
